import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { GrocyBasics } from '../../../core/entities/grocy/shared/basics.entity';
import { FormOptions } from '../../form-options/base.form-options';
import { fieldIsRequired } from '../../utils/forms.utils';

@Component({
  selector: 'app-months-input',
  templateUrl: './months-input.component.html',
  styleUrl: './months-input.component.scss',
})
export class MonthsInputComponent {
  @Input({ required: true }) control!: FormControl<GrocyBasics[] | null>;
  @Input() label: string = 'Months';

  isRequired = fieldIsRequired;
  options = new FormOptions().months;
}
